import React from "react";
import EditorHeader from "../../modules/EditorHeader/EditorHeader";
// import Footer from "../../modules/footer/Footer";
import Sidebar from "../../modules/sidebar/Sidebar";
import Editor from "../../modules/editor/Editor";

export default function EditorTemp() {
  return (
    <>
      <EditorHeader />
      <Sidebar />
      <Editor />
    </>
  );
}
